/**
 * [!!!]simplified and change version (source: lodash 4.9.0-npm)
 * return new Object
 *
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function eq(value, other) {
  return value === other || (value !== value && other !== other)
}

function assignValue(object, key, value) {
  var objValue = object[key]
  if (
    !(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
    (value === undefined && !(key in object))
  ) {
    object[key] = value
  }
}

var assign = function () {
  const temp = {}

  for (let i = 0; i < arguments.length; i++) {
    const obj = arguments[i]
    for (let key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        assignValue(temp, key, obj[key])
      }
    }
  }
  return temp
}

export default assign
